import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';

import styles from './style.css';


const AdminConfirmModal = (props) => {
  const { show, close, deleteUser, id } = props;

  const onDeleteSelectedUser = useCallback(() => {
    deleteUser(id);
    close();
  }, [close, deleteUser, id]);

  return (
    <Modal background="white" close={close} show={show} size="medium">
      <h5 className={styles.modalTitle}>Are you sure?</h5>
      <div className={styles.buttonWrapper}>
        <Button colour="orange" label="Cancel" onClick={close} />
        <Button colour="orange" label="Yes" onClick={onDeleteSelectedUser} />
      </div>
    </Modal>
  );
};
AdminConfirmModal.propTypes = {
  close: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
};

export default AdminConfirmModal;
